import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicExclusiveNet from "../Components/ProjPicExclusiveNet";

const ProjectPageExclusiveNet = () => {
    return (
        <>
            <Navbar />
            <ProjPicExclusiveNet />
            <Footer />
        </>
    );
};

export default ProjectPageExclusiveNet;
